<template>
    <div class="modal-card card">
        <form @submit.prevent="handleSubmit">
            <div class="card-header">
                <!-- Title -->
                <h4 class="card-header-title">
                    Add Credential
                </h4>
                <!-- Close -->
                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div class="card-body">
                <InputField label="Choose a Sandbox" class="mb-4" type="select" :options="sandboxOptions"
                    v-model="sandbox" />
                <hr class="mb-4">
                <h4>Credential Details</h4>
                <FormFields :fields="credFields" v-model="credential" :editMode="true" :inlineField="true" />
            </div>
            <div class="card-footer">
                <div class="d-flex justify-content-between align-items-center">
                    <div>
                        <div class="text-danger">
                            {{ error }}
                        </div>
                    </div>
                    <SubmitButton :loading="loading" :fields="credFields" v-model="credential"/>
                </div>
            </div>
        </form>
    </div>
</template>

<script>
import InputField from '../InputField.vue'
import FormFields from '../FormFields.vue'
import SubmitButton from '../SubmitButton.vue'
import sandboxAquacredCredentials from '../../utils/field-constants/sandboxAquacredCredentials'
import { mapActions } from 'vuex'
export default {
    components: { InputField, FormFields, SubmitButton },
    props: {
        modalData: {
            type: Object,
            default: () => ({})
        }
    },
    data() {
        return {
            loading: false,
            error: "",
            sandbox: this.modalData.sandbox,
            credential: {
                name: "",
                type: "aqfer"
            },
            sandboxCredFields: JSON.parse(JSON.stringify(sandboxAquacredCredentials))
        }
    },
    name: "AddAquacredCredential",
    computed: {
        credFields() {
            let fields = this.sandboxCredFields.map((field) => {
                return {
                    ...field,
                    editable: true,
                    visible: field.filterByType.includes(this.credential.type)
                };
            });
            return fields;
        },
        sandboxOptions() {
            let devSandboxes = this.$store.state.sandbox.devSandboxes ? this.$store.state.sandbox.devSandboxes : [];
            let prodV2Sandboxes = this.$store.state.sandbox.prodV2Sandboxes ? this.$store.state.sandbox.prodV2Sandboxes : [];
            let sandboxes = [...devSandboxes, ...prodV2Sandboxes]
            return sandboxes.map((sandbox) => {
                return { "label": sandbox.name + " - " + sandbox.env, "value": sandbox.name };
            });
        },
    },
    methods: {
        ...mapActions('amdp', {
            insertAquacredCredential: 'upsertAquacredCredential'
        }),
        async handleSubmit() {
            this.error = "";
            this.loading = true;
            try {
                let payload = {
                    name: this.credential.name,
                    type: this.credential.type,
                }
                // add only visible fields to payload
                this.credFields.map((field) => {
                    if (field.visible && this.credential[field.name]) {
                        payload[field.name] = this.credential[field.name];
                    }
                });
                await this.insertAquacredCredential({
                    service: 'amdp',
                    namespace: this.sandbox,
                    credentialName: this.credential.name,
                    payload: payload
                });
                this.$store.dispatch('addToast', {
                    message: "Credential added successfully.",
                    type: 'success'
                });
                this.$store.dispatch('hideModal');
                if (this.modalData?.refreshCredentials && typeof this.modalData.refreshCredentials === 'function') {
                    this.modalData.refreshCredentials();
                }
            } catch (error) {
                this.error = error?.response?.data?.error || error?.message;
                console.error(this.error);
                this.$store.dispatch('addToast', {
                    message: "Something went wrong while updating credential. Please contact support.",
                    type: 'error'
                });
            } finally {
                this.loading = false;
            }
        },
    },
};
</script>

<style></style>